import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import concat from 'ramda/es/concat';
import values from 'ramda/es/values';
import filter from 'ramda/es/filter';
import complement from 'ramda/es/complement';
import propEq from 'ramda/es/propEq';
import map from 'ramda/es/map';
import assoc from 'ramda/es/assoc';

import { TARIFF_FIRST_OF_MONTH } from 'app/common/constants/tariffs';
import composePackTariff from 'app/components/Tariff/composePackTariff';
import selectActiveServices from 'app/components/Tariff/selectActiveServices';
import { sortByTitle } from 'app/common/lib/sort';


const filterUnusedTariffs = filter(complement(propEq('kind', TARIFF_FIRST_OF_MONTH)));

const selectTariffs = createSelector(
  state => state.finances.tariffs.tariffs,
  pipe(
    values,
    filterUnusedTariffs,
    sortByTitle,
    map(obj => assoc('key', obj.id, obj))
  )
);

const selectBundles = createSelector(
  [
    state => state.finances.tariffs.bundles,
    state => state.finances.tariffs.bundles_tariffs,
    (_, { service }) => service,
    selectActiveServices,
  ],
  (bundles, bundlesTariffs, currentService, activeServices) => pipe(
    values,
    sortByTitle,
    map(composePackTariff(bundlesTariffs, currentService, activeServices))
  )(bundles)
);

// id могут пересекаться
export default createSelector(selectBundles, selectTariffs, concat);
